import { PropsWithChildren } from 'react';

export type UIProviderProps = PropsWithChildren;

/**
 * UIProvider - Pure Tailwind setup.
 * Toasts delegate to legacy AngularJS toastr (survives hash-based navigation).
 * When AngularJS is fully removed, add a React toast library here.
 */
export function UIProvider({ children }: UIProviderProps) {
  return <>{children}</>;
}
